<template>
  <div>
    <Modal v-model="$store.state.showSubPop" width="400">
      <div class="close_box">
        <img class="close_icon" src="../../assets/image/tbm/modal_close.png" @click="closeModal" />
      </div>
      <div class="modal_content">
        <div class="sub_text" style="margin-bottom: 23px">
          即刻订阅电子报，
          <br />立享优先选购THOM BROWNE最新系列与专属活动通知
        </div>
        <div class="sub_text">订阅手机号：{{ userPhoneText($store.state.phoneNumber) }}</div>
        <div class="sub_btn" @click="changeSub(true)">
          订阅
          <Icon type="ios-arrow-forward" />
        </div>
        <div class="sub_btn_cancel" @click="changeSub(false)">
          取消
          <Icon type="ios-arrow-back" style="color:#000000" />
        </div>
      </div>
    </Modal>
    <Modal v-model="subModalEnd" width="315">
      <div class="close_box">
        <img
          class="close_icon"
          src="../../assets/image/tbm/modal_close.png"
          @click="subModalEnd=false"
        />
      </div>
      <div class="modal_content" style="padding: 0px 20px 20px 20px">
        <img class="sub_img" src="https://static.getconnectplus.com/tb_webassets/tb_subscribed.png?x-oss-process=style/tb" />
        <div class="sub_text" style="margin-bottom: 23px">非常感谢。您已订阅成功。</div>
        <div class="sub_text">我们将会第一时间向您推送新品资讯和专属活动邀请。</div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subModalEnd: false
    };
  },
  methods: {
    closeModal() {
      this.$store.commit("setValue", ["showSubPop", false]);
    },
    userExit() {
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("token");
      let isExitlogin = !this.$store.state.isExitlogin;
      this.$store.commit("UpdateLoginStatus", isExitlogin);
      this.$router.push({ name: "login" });
    },
    changeSub(val) {
      let url = this.$store.state.API.customer.subSet;
      let params = {
        shoppingPreference: this.$store.state.shoppingPreferenceTypes,
        subscribePreference: val
      };
      this.$http
        .post(url, params, {
          headers: { tb_token: window.localStorage.getItem("token") }
        })
        .then(res => {
          if (res.status == 200) {
         
            if (res.data.returnCode == "00") {
              var data = res.data.returnData;
              window.localStorage.setItem("userInfo", JSON.stringify(data));
              this.$store.commit("resetUserInfo", data);
              this.$store.commit("setValue", ["showSubPop", false]);
              this.$store.commit("setValue", ["userLogin", true]);
              if (val) {
                this.subModalEnd = true;
              } else {
                this.$Message.success("您已取消订阅");
              }
            } else {
              this.$store.commit("setValue", ["showSubPop", false]);
              //this.$Message.error(res.data.message);
              this.userExit();
              this.$Message.error({
                content: "登录已过期，请重新登录",
                duration: 3
              });
            }
          }
        });
    },
    userPhoneText(val) {
      if (val) {
        let frontText = val.substring(0, 3);
        let behindText = val.substring(val.length - 4, val.length);
        return frontText + "****" + behindText;
      }
    }
  }
};
</script>

<style scoped lang='less'>
.close_box {
  display: flex;
  .close_icon {
    cursor: pointer;
    margin-left: auto;
    width: 7px;
    height: 9px;
    margin-bottom: 15px;
  }
}
.modal_content {
  .sub_img {
    width: 100%;
    height: 178px;
    margin-bottom: 30px;
  }
  .sub_text {
    text-align: left;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c5d5f;
  }
  .sub_btn {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    background: #5c5d5f;
    border: 1px solid #5c5d5f;
    line-height: 34px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 33px;
    padding: 0px 20px;
  }
  .sub_btn_cancel {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    background: #ffffff;
    border: 1px solid #5c5d5f;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5c5d5f;
    line-height: 32px;
    padding: 0px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SubPop.vue